/**
 * @param {String} rawHex
 * @return {Array} [r, g, b]
 */
function hexToRgb (rawHex: string) {

	let hex = rawHex;
	let r;
	let g;
	let b;

	// remove prefix if one exists
	if (rawHex.charAt(0) === '#') {

		hex = rawHex.substr(1);

	}

	if (hex.length === 3) {

		// short version
		r = hex.substr(0, 1);
		g = hex.substr(1, 1);
		b = hex.substr(2, 1);
		r += r;
		g += g;
		b += b;

	} else if (hex.length === 6) {

		// long version
		r = hex.substr(0, 2);
		g = hex.substr(2, 2);
		b = hex.substr(4, 2);

	} else {

		// incorect hex color string
		throw new Error('Incorect hex color string');

	}

	// convert hex to decimal
	r = parseInt(r, 16);
	g = parseInt(g, 16);
	b = parseInt(b, 16);

	return [ r, g, b ];

}

/**
 * @param {Array} rawRgb
 * @return {String}
 */
/* eslint no-bitwise: 0 */
function rgbToHex (rawRgb: number[]) {

	const rgb = rawRgb.map((el) => parseInt(el.toString(), 10));

	return `#${((1 << 24) + (rgb[0] << 16) + (rgb[1] << 8) + rgb[2]).toString(16).slice(1)}`;

}

export { hexToRgb, rgbToHex };
